import React, { Component } from 'react'
import { connect } from 'react-redux'
// import Datetime from 'react-datetime'
import async from 'async'

import { API_URL } from '../../../constants'

// Utils
import { openOverlay } from '../../../actions/common'

// import components
import Header from '../../../shared/components/Header'

// import components
import Dropzone from '../../../shared/components/Dropzone'
import Gallery from '../../../shared/components/Gallery'
// import HelpText from '../../../shared/components/HelpText'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
/* import LeftMenu from '../../../shared/components/Menus/LeftMenu' */
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'

import TaskOverlay from '../../../shared/overlays/TaskOverlay'

// Actions
import {
  getTask,
  createUpdateTask,
  fileUpload,
  fileDelete,
  getCategories,
  getDeadline
} from '../../../actions/tasks'
import { getShops } from '../../../actions/shops'

// import styles
import './index.scss'
import '../tasks.scss'
import '../../../shared/components/Gallery/gallery.scss'

// Utils
import { translation, enumtranslate } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'

// Elements
import Button from '../../../shared/elements/button'
import Check from '../../../shared/elements/check'
import Radio from '../../../shared/elements/radio'
import Text from '../../../shared/elements/text'
import Textarea from '../../../shared/elements/textarea'
import Panel from '../../../shared/elements/panel'
import Col from '../../../shared/elements/col'
import Row from '../../../shared/elements/row'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import DropDown from '../../../shared/elements/dropDown'
import Switch from '../../../shared/elements/switch'
import DateTime from '../../../shared/elements/datetime'
import Divider from '../../../shared/elements/divider'
import Label from '../../../shared/elements/label'
import TableHeader from '../../../shared/elements/tableHeader'
import TableExpand from '../../../shared/elements/tableExpand'
import TableRow from '../../../shared/elements/tableRow'
import TableContainer from '../../../shared/elements/tableContainer'
// import HelpIcon from '../../../shared/elements/helpIcon'
// import PanelHeader from '../../../shared/elements/panelHeader'
import Grid from '../../../shared/elements/grid'
import Icon from '../../../shared/elements/icon'
import { MainMenuIcons } from '../../../shared/elements/icons'
import CloseButton from '../../../shared/elements/closeButton'
import RemoveButton from '../../../shared/elements/removeButton'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuCustomItem from '../../../shared/elements/sideMenuCustomItem'

class Tasks extends Component {
  constructor (props) {
    super(props)
    this.state = {
      task: {
        OtherTaskId: 0,
        StartDate: window.CustomDate(),
        EndDate: window.CustomDate(),
        NoEndDate: true,
        Description: '',
        Deadline: {
          Id: 0,
          CreatedBy: 0,
          CreatedDate: window.CustomDate(),
          PuplishDayCount: 7, // Default value
          OccurrenceType: 1,
          DeadlineType: 0,
          SpecificDay: 1,
          Month: 1,
          WeekDay: 1,
          StartEnd: 0,
          OnlyOneDeadline: false,
          IsChain: false
        },
        CategoryId: 1,
        IsActive: false,
        IsUnsecified: false,
        Name: '',
        OtherTaskLog: [],
        Assigns: [],
        OtherTaskFiles: [],
        AssignsOnlyFirst: false,
        HasNextOccurrence: false
      },
      upload: {
        loading: false,
        errors: []
      },
      categories: [],
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      shops: [],
      DedlineChanged: false,
      ConfirmDedlineChange: false,
      isUserChain: false,
      taskOccurrence: {
        task: {}
      }
    }

    this.onChange = this.onChange.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onChangeList = this.onChangeList.bind(this)
    this.onChangeNumber = this.onChangeNumber.bind(this)
    this.onClickCheckbox = this.onClickCheckbox.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.updateTask = this.updateTask.bind(this)
    this.renderButton = this.renderButton.bind(this)
    this.occurrenceInterval = this.occurrenceInterval.bind(this)
  }

  componentDidMount () {
    // get task
    if (this.props.params.tasksID > 0) {
      this.getTaskById(this.props.params.tasksID)
    }
    // get categories
    this.getCategories()
    this.getShops()
    this.updateDeadline()

    this.setState({
      isUserChain: this.props.auth.user.AccessLevel === 2
    })
  }

  getShops () {
    if (this.props.auth.user.AccessLevel === 2) {
      this.props.getShops(this.props.auth.user.ChainId).then((res) => {
        this.setState({
          shops: res.data.filter(x => x.Active === true)
        })
      })
    }
  }

  onChange (type, e) {
    // console.log('this.state.task.Deadline.SpecificDay ', this.state.task.Deadline.SpecificDay)
    if (type === 'deadline') {
      this.setState({
        task: {
          ...this.state.task,
          Deadline: {
            ...this.state.task.Deadline,
            [e.target.name]: Number(e.target.value)
          }
        },
        DedlineChanged: true
      }, this.updateTask)
    } else {
      if (typeof type !== 'string') e = type
      this.setState({
        task: {
          ...this.state.task,
          [e.target.name]: e.target.value
        }
      }, () => {
        if (type !== 'Description') this.updateTask
      }
)
    }
  }

  onChangeNumber (e) {
    this.setState({
      task: {
        ...this.state.task,
        [e.target.name]: Number(e.target.value)
      }
    }, this.updateTask)
  }

  onChangeDate (name, value) {
    let deadlineChanged = (name === 'StartDate' && this.state.task.Deadline.OnlyOneDeadline)
    this.setState({
      task: {
        ...this.state.task,
        [name]: value
      },
      DedlineChanged: deadlineChanged
    })
  }

  onChangeList (e) {
    let assigns = this.state.task.Assigns
    if (e.target.checked) {
      if (this.state.isUserChain) {
        if (e.target.name === 'all') {
          // Filter out all shops
          assigns = assigns.filter(a => a.CompanyId === null)
          // Add all shops
          this.state.shops.map(x => x.Active === true && assigns.push({ CompanyId: x.ShopId }))
        } else {
          assigns.push({ CompanyId: e.target.id })
        }
      } else {
        if (e.target.name === 'all') {
          // Filter out all employees, who do not exist in list (Keep employees from other shops!)
          assigns = assigns.filter(a => a.UserId === null || !this.props.employees.find(e => e.UserId === a.UserId))
          // Add all employees
          this.props.employees.map(x => assigns.push({ UserId: x.UserId }))
        } else {
          assigns.push({ UserId: e.target.id })
        }
      }
    } else {
      if (e.target.name === 'all') {
        if (this.state.isUserChain) {
          // Filter out all shops
          assigns = assigns.filter(a => a.CompanyId === null)
        } else {
          // Filter out all employees
          assigns = assigns.filter(a => a.UserId === null)
        }
      } else {
        assigns = assigns.filter(otu => Number(otu.UserId ? otu.UserId : otu.CompanyId) !== Number(e.target.id))
      }
    }

    this.setState({
      task: {
        ...this.state.task,
        Assigns: assigns
      }
    }, this.updateTask)
  }

  onClickCheckbox (type, e) {
    if (type === 'deadline') {
      this.setState({
        task: {
          ...this.state.task,
          Deadline: {
            ...this.state.task.Deadline,
            WeekDay: Number(e.target.name)
          }
        },
        DedlineChanged: true
      },
      this.updateTask)
    } else {
      if (typeof type !== 'string') e = type
      if (e.target.id === 'allOrc') e.target.checked = false

      let deadline = { ...this.state.task.Deadline }
      if (e.target.name === 'IsUnsecified' && !e.target.checked) {
        deadline.OccurrenceType = 1
        deadline.WeekDay = 1
      }

      this.setState({
        task: {
          ...this.state.task,
          Deadline: deadline,
          [e.target.name]: e.target.checked
        }
      },
      this.updateTask)
    }
  }

  onRadioChange (type, e) {
    if (type === 'deadline') {
      this.setState({
        task: {
          ...this.state.task,
          Deadline: {
            ...this.state.task.Deadline,
            [e.target.name]: isNaN(e.target.value) === false ? Number(e.target.value) : e.target.value === 'true'
          }
        },
        DedlineChanged: true
      }, this.updateTask)
    } else {
      if (typeof type !== 'string') e = type
      let value = e.target.value
      if (e.target.name === 'IsActive') value = e.target.checked
      this.setState({
        task: {
          ...this.state.task,
          [e.target.name]: String(value) === 'true'
        }
      },
      this.updateTask)
    }
  }

  updateDeadline () {
    if (this.props.params.tasksID === '0' || this.props.params.taskID === 0) {
      const formatDate = (date, fromDate) => {
        if (date === null || date === '' || date === undefined) {
          date = new Date(fromDate)
        }
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DDTHH:mm:ss')
        }
        return date
      }
      let task = {...this.state.task, OtherTaskId: this.props.params.tasksID}
      if (this.state.task.NoEndDate === false && this.state.task.EndDate === null) {
        task.StartDate = formatDate(task.StartDate)
        task.EndDate = formatDate(task.EndDate, task.StartDate)
      }
      this.props.getDeadline(task).then((res) => {
        this.setState({
          task: {
            ...res.data
          }
        })
      })
    }
  }

  updateTask (goThrough, e) {
    if (typeof goThrough !== 'string') e = goThrough
    if (this.state.task.OtherTaskId === 0 && goThrough !== 'yes') {
      this.updateDeadline()
      return null
    }
    if (this.state.task.Name.length > 0) {
      const formatDate = (date, fromDate) => {
        if (date === null || date === '' || date === undefined) {
          date = new Date(fromDate)
        }
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DDTHH:mm:ss')
        }
        return date
      }

      let task = {...this.state.task}
      task.StartDate = formatDate(task.StartDate)
      task.EndDate = formatDate(task.EndDate, task.StartDate)
      this.updateDeadline()
      return this.props.createUpdateTask(task).then((res) => {
        // Toastr
        // window.toastr.success(translation('1828'), translation('13424'))
        if (task.OtherTaskId === 0 || task.isDeleted) { // if create or delete
          if (task.isDeleted) this.context.router.goBack()
          else {
            this.setState({
              task: res.data
            }, () => {
              this.state.task.IsActive ? this.context.router.replace('/tasks/' + this.state.task.OtherTaskId) : this.context.router.replace('/tasks/')
            })
          }
        } else { // if edit
          this.setState({
            task: res.data
          })
        }

        // if (task.OtherTaskId !== 0 && !task.isDeleted) { // if not create nor delete
        //   this.setState({
        //     task: res.data
        //   })
        // } else {
        //   this.context.router.replace('/tasks/')
        // }

        // this.setState({
        //   task: res.data
        // }, () => {
        //   if (task.OtherTaskId === 0) {
        //     this.context.router.replace('/tasks/') // + res.data.OtherTaskId)
        //   }
        // })
      }, () => {
        // Toastr
        window.toastr.error(translation('1829'), translation('216'))
      })
    } else {
      this.updateDeadline()
      // Toastr
      if (this.state.task.Name.length > 1) {
        window.toastr.error(translation('2243'), translation('216'))
      } else {
        window.toastr.error(translation('13430'), translation('216'))
      }
    }
  }

  getTaskById (id) {
    this.props.getTask(id).then((res) => {
      this.setState({
        task: res.data
      })
    })
  }

  getCategories () {
    this.props.getCategories().then((res) => {
      this.setState({
        categories: res.data,
        task: {
          ...this.state.task,
          CategoryId: res.data[0].Id
        }
      })
    })
  }

  occurrenceInterval () {
    let type = this.state.task.Deadline.OccurrenceType
    const isDisabled = this.state.task.IsUnsecified || (this.state.task.IsChain && !this.state.isUserChain)

    const monthSelector = (e) => {
      return (
        <DropDown size='s' disabled={this.state.task.Deadline.DeadlineType !== e || isDisabled} key='monthSelector' name='Month' onChange={this.onChange.bind(this, 'deadline')} value={this.state.task.Deadline.Month}>
          <option value={1}>{translation('239')}</option>
          <option value={2}>{translation('240')}</option>
          <option value={3}>{translation('241')}</option>
          <option value={4}>{translation('242')}</option>
          <option value={5}>{translation('243')}</option>
          <option value={6}>{translation('244')}</option>
          <option value={7}>{translation('245')}</option>
          <option value={8}>{translation('246')}</option>
          <option value={9}>{translation('247')}</option>
          <option value={10}>{translation('276')}</option>
          <option value={11}>{translation('248')}</option>
          <option value={12}>{translation('249')}</option>
        </DropDown>
      )
    }

    const getMaxDay = () => {
      if (this.state.task.Deadline.OccurrenceType === 3) {
        return 92
      } else if (this.state.task.Deadline.OccurrenceType === 2) {
        return 31
      } else {
        return new Date(new Date().getFullYear(), this.state.task.Deadline.Month, 0).getDate()
      }
    }
    let deadline = ''
    if (this.state.task.OtherTaskLog.filter(otl => !otl.IsChange).length > 0) {
      deadline = renderFullDate(this.state.task.OtherTaskLog.filter(otl => !otl.IsChange)[0].Deadline, false)
    }
    return (
      <div>
        <LabelWrapper labelText={translation('1825')}>
          <Radio labelText={translation('1818')} disabled={isDisabled} id='weekly' value='1' name='OccurrenceType' checked={this.state.task.Deadline.OccurrenceType === 1} onChange={this.onRadioChange.bind(this, 'deadline')} />
          <Radio labelText={translation('1819')} disabled={isDisabled} id='monthly' value='2' name='OccurrenceType' checked={this.state.task.Deadline.OccurrenceType === 2} onChange={this.onRadioChange.bind(this, 'deadline')} />
          <Radio labelText={translation('1820')} disabled={isDisabled} id='quaterly' value='3' name='OccurrenceType' checked={this.state.task.Deadline.OccurrenceType === 3} onChange={this.onRadioChange.bind(this, 'deadline')} />
          <Radio labelText={translation('15053')} disabled={isDisabled} id='yearly' value='4' name='OccurrenceType' checked={this.state.task.Deadline.OccurrenceType === 4} onChange={this.onRadioChange.bind(this, 'deadline')} />
        </LabelWrapper>
        <Divider />
        {type === 0 && <div />}
        {type === 1 && (
          <div>
            <div className='selectForWeek'>
              <Radio labelText={translation('169')} disabled={isDisabled} id='mon' name={1} onChange={this.onClickCheckbox.bind(this, 'deadline')} checked={this.state.task.Deadline.WeekDay === 1} />
              <Radio labelText={translation('170')} disabled={isDisabled} id='tue' name={2} onChange={this.onClickCheckbox.bind(this, 'deadline')} checked={this.state.task.Deadline.WeekDay === 2} />
              <Radio labelText={translation('171')} disabled={isDisabled} id='wed' name={3} onChange={this.onClickCheckbox.bind(this, 'deadline')} checked={this.state.task.Deadline.WeekDay === 3} />
              <Radio labelText={translation('172')} disabled={isDisabled} id='thu' name={4} onChange={this.onClickCheckbox.bind(this, 'deadline')} checked={this.state.task.Deadline.WeekDay === 4} />
              <Radio labelText={translation('173')} disabled={isDisabled} id='fri' name={5} onChange={this.onClickCheckbox.bind(this, 'deadline')} checked={this.state.task.Deadline.WeekDay === 5} />
            </div>
            <div className='nextOccurrence'>
              {!this.state.task.HasNextOccurrence && (<label>{translation('15331') + translation('15332')}</label>)}
              {this.state.task.HasNextOccurrence && (<label>{translation('15331') + deadline}</label>)}
            </div>
          </div>
        )}
        {[2, 3, 4].indexOf(type) > -1 && (
          <div className='pg-mt-2'>
            <Grid cols={`auto auto ${type === 4 ? 'min-content' : ''} auto`} align='center' spacing={2}>
              <Radio spacing={0} labelText={translation('15054')} disabled={isDisabled} id='month_Specific' name='DeadlineType' value={0} checked={this.state.task.Deadline.DeadlineType === 0} onChange={this.onRadioChange.bind(this, 'deadline')} />
              <Text size='s' type='number' min='1' max={getMaxDay()} id='numberDay' name='SpecificDay' disabled={this.state.task.Deadline.DeadlineType !== 0 || isDisabled} onChange={this.onChange.bind(this, 'deadline')} value={isNaN(this.state.task.Deadline.SpecificDay) ? 0 : this.state.task.Deadline.SpecificDay} />
              {type === 2 && <Label>{translation('15055')}</Label>}
              {type === 3 && <Label>{translation('15056')}</Label>}
              {type === 4 && ([
                <Label key='label'>-</Label>,
                monthSelector(0)
              ])}
            </Grid>
            <Grid cols={`max-content auto ${type !== 4 ? 'auto' : ''}`} align='center' spacing={2}>
              <Radio spacing={0} labelText={translation('15057')} disabled={isDisabled} id='StartEnd_Month' name='DeadlineType' value={1} checked={this.state.task.Deadline.DeadlineType === 1} onChange={this.onRadioChange.bind(this, 'deadline')} />
              <DropDown size='s' name='StartEnd' disabled={this.state.task.Deadline.DeadlineType !== 1 || isDisabled} onChange={this.onChange.bind(this, 'deadline')} value={this.state.task.Deadline.StartEnd}>
                <option value={0}>{translation('15058')}</option>
                <option value={1}>{translation('15059')}</option>
                <option value={2}>{translation('15060')}</option>
                <option value={3}>{translation('15061')}</option>
                <option value={4}>{translation('15062')}</option>
              </DropDown>
              {type === 2 && <Label>{translation('15063')}</Label>}
              {type === 3 && <Label>{translation('15064')}</Label>}
              {type === 4 && ([
                <Label key='label'>{translation('15065')}</Label>,
                monthSelector(1)
              ])}
            </Grid>
            <div className='nextOccurrence'>
              {!(this.state.task.HasNextOccurrence) && (<label>{translation('15331') + translation('15332')}</label>)}
              {(this.state.task.HasNextOccurrence) && (<label>{translation('15331') + deadline}</label>)}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderDeadline () {
    const isDisabled = this.state.task.IsUnsecified || (this.state.task.IsChain && !this.state.isUserChain)
    let inputProps = {
      placeholder: translation('1728'),
      readOnly: true,
      disabled: isDisabled
    }
    let StartDate = this.state.task.StartDate
    let EndDate = this.state.task.EndDate

    // Date
    let renderStartDate = ''
    if (typeof StartDate !== 'undefined' && StartDate !== null && StartDate !== '') {
      renderStartDate = window.CustomDate(StartDate)
    }

    let renderEndDate = this.state.task.EndDate
    if (typeof EndDate !== 'undefined' && EndDate !== null && EndDate !== '') {
      renderEndDate = window.CustomDate(EndDate)
    }
    return (
      <Panel title={translation('1232')} helpText={translation('1981')}>
        <Radio labelText={translation('15079')} disabled={isDisabled} id='onlyOne' value='true' name='OnlyOneDeadline' checked={this.state.task.Deadline.OnlyOneDeadline} onChange={this.onRadioChange.bind(this, 'deadline')} />
        <Radio labelText={translation('15080')} disabled={isDisabled} id='menny' value='false' name='OnlyOneDeadline' checked={!this.state.task.Deadline.OnlyOneDeadline} onChange={this.onRadioChange.bind(this, 'deadline')} />
        {this.state.task.Deadline.OnlyOneDeadline && (
          <div className='datepicker-fullwidth control__field'>
            <DateTime
              labelText={translation('1232')}
              inputProps={inputProps}
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              closeOnSelect
              value={renderStartDate}
              onChange={this.onChangeDate.bind(this, 'StartDate')}
              onBlur={this.updateTask} />
          </div>
        )}
        {this.state.task.Deadline.OnlyOneDeadline === false && [
          <div key={'DeadlineDate'}>
            <DateTime
              labelText={translation('573')}
              inputProps={inputProps}
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              closeOnSelect
              value={renderStartDate}
              onChange={this.onChangeDate.bind(this, 'StartDate')}
              onBlur={this.updateTask}
            />
            <DateTime
              labelText={translation('574')}
              inputProps={{ ...inputProps, disabled: (isDisabled || this.state.task.NoEndDate) }}
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              closeOnSelect
              isValidDate={x => new Date(x) > new Date(renderStartDate)}
              readOnly={this.state.task.NoEndDate}
              value={renderEndDate}
              onChange={this.onChangeDate.bind(this, 'EndDate')}
              onBlur={this.updateTask}
            />
            <Check disabled={isDisabled} id='noEndDate' name='NoEndDate' onChange={this.onClickCheckbox} checked={this.state.task.NoEndDate} labelText={translation('15066')} />
          </div>,
          <div key={'DeadlineOccurrences'}>
            {this.occurrenceInterval()}
          </div>
        ]}
        <Text labelText={translation('2020')} type='number' disabled={isDisabled} min='0' name='PuplishDayCount' onChange={this.onChange.bind(this, 'deadline')} value={this.state.task.Deadline.PuplishDayCount} />
      </Panel>
    )
  }

  renderFiles () {
    let { errors } = this.state.upload
    const notDisabled = !(this.state.task.IsChain && !this.state.isUserChain)

    // Delete file
    const deleteFile = (file) => {
      let newErrors = []
      var deleteFileId = {ItemId: file.OrderFileId}
      this.props.fileDelete(deleteFileId).then((res) => {
        // delete from database
        var array = this.state.task.OtherTaskFiles
        this.setState({
          task: {
            ...this.state.task,
            OtherTaskFiles: array.filter((el) => { return el.OrderFileId !== Number(file.OrderFileId) })
          }
        },
        this.updateTask
        )
      }, () => {
        newErrors.push(translation('1207') + ': ' + file.FileName)
        this.setState({
          upload: { ...this.state.upload, errors: newErrors }
        })
      })
    }

    const deleteConfirmation = file => {
      this.setState({
        confirmFileDelete: {
          confirm: true,
          file
        }
      })
    }

    // Render file
    const renderFile = (file, index) => {
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
      return (
        <li key={index} className='file-document'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <a target='_BLANK' href={file.FileURL}>
            {file.FileName}
          </a>
          {this.props.auth.user.CustomerId === '-1' && notDisabled && <div className='file-delete'><RemoveButton onClick={() => deleteConfirmation(file)} size='s' /></div>}
        </li>
      )
    }
    // Render image
    const renderImage = (image, key) => {
      return (
        <div key={key}>
          <a href={image.FileURL} data-lightbox='gallery' data-title={image.FileName}><img src={image.ThumbURL} /></a>
          {this.props.auth.user.CustomerId === '-1' && notDisabled && <div className='file-delete'><RemoveButton onClick={() => deleteConfirmation(image)} size='s' /></div>}
        </div>
      )
    }

    const onConfirm = () => {
      const file = this.state.confirmFileDelete.file
      const confirm = {
        confirm: false,
        file: null
      }

      this.setState({
        confirmFileDelete: confirm
      }, () => {
        deleteFile(file)
      })
    }

    const notConfirm = () => {
      const confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }
    // On drop
    const onDrop = () => {
      this.setState({ upload: {
        ...this.state.upload,
        errors: []
      } })
    }
    // On drop accepted
    const onDropAccepted = (files) => {
      let newErrors = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true
        }
      })
      async.each(files, (file, cb) => {
        // Upload each file
        this.props.fileUpload(file, 0).then((res) => {
          this.setState({
            task: {
              ...this.state.task,
              OtherTaskFiles: [
                ...this.state.task.OtherTaskFiles,
                {
                  OtherTaskId: this.state.task.OtherTaskId,
                  OrderFileId: res.data[0].OrderFileID,
                  IsImage: res.data[0].IsImage,
                  FileURL: res.data[0].RealFileURL,
                  FileName: res.data[0].FileName,
                  ThumbURL: res.data[0].RealThumbURL
                }
              ]
            }
          })
          cb()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            }
          })
        }
        this.setState({
          upload: {
            ...this.state.upload,
            loading: false
          }
        })
        this.updateTask()
      })
    }
    // On drop rejected
    const onDropRejected = (files) => {
      let newErrors = []
      files.map((val, index) => {
        newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
      })
      this.setState({ upload: { ...this.state.upload, errors: newErrors } })
    }
    // Render error
    const renderError = (error, index) => <p key={index}>{error}</p>
    let imgFiles = []
    let docFiles = []
    this.state.task.OtherTaskFiles.forEach(file => file.IsImage ? imgFiles.push(file) : docFiles.push(file))

    // Render
    let isMultipleUpload = true
    return (
      <div className='files'>
        <div className='title'>{translation('1043')}</div>
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
        {notDisabled && (
          <Dropzone
            onDrop={onDrop}
            onDropAccepted={onDropAccepted}
            onDropRejected={onDropRejected}
            multiple={isMultipleUpload}
            includeCircles={false}>
            {this.state.upload.loading && (
              <div className='loading'>
                <div className='animated-background'>
                  <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                  <span className='sr-only'>{translation('13382')}...</span>
                </div>
              </div>
            )}
            {!this.state.upload.loading && (
              <div><p>{translation('13397')}</p></div>
            )}
          </Dropzone>
        )}
        <div className='files_inner clearfix'>
          <div className='gallery'>
            <ul>
              {docFiles.map(renderFile)}
            </ul>
          </div>
          <Gallery files={imgFiles} renderImage={renderImage} />
        </div>
        {this.state.confirmFileDelete.confirm && (
          <Portal className='deleteModal' onPortalClose={notConfirm}>
            <Confirm confirm={onConfirm} notConfirm={notConfirm} />
          </Portal>
        )}
      </div>
    )
  }

  renderButton () {
    const deleteTask = () => {
      this.setState({
        task: {
          ...this.state.task,
          confirmDelete: true
        }
      })
    }

    const onConfirm = () => {
      this.setState({
        task: {
          ...this.state.task,
          isDeleted: true,
          confirmDelete: false
        }
      }, () => this.updateTask())// .then(this.context.router.goBack()))
    }

    const closeConfirm = () => {
      this.setState({
        task: {
          ...this.state.task,
          confirmDelete: false
        }
      })
    }

    if (this.state.task.OtherTaskId === 0) {
      return (<Button onClick={this.updateTask.bind(this, 'yes')} className='saveButton' labelText={translation('2056')} />)
    } else {
      return (<Button onClick={deleteTask} className='saveButton' style='alert' labelText={translation('15081')}>
        {this.state.task.confirmDelete && <Portal className='deleteModal' onPortalClose={closeConfirm}>
          <Confirm
            confirm={onConfirm}
            notConfirm={closeConfirm}
            renderText={() => {
              return (<div>{translation('15082')}</div>)
            }}
          />
        </Portal>}
      </Button>)
    }
  }

  renderAssignList () {
    const isDisabled = this.state.task.IsUnsecified || (this.state.task.IsChain && !this.state.isUserChain)
    let list = this.state.isUserChain ? this.state.shops : this.props.employees
    const assignsList = (val, key) => {
      if (!val.Active) return null

      const name = val.Name ? val.Name : val.ShopName
      const Id = val.UserId ? val.UserId : val.ShopId
      const checkedId = this.state.task.Assigns.find((x) => (x.UserId ? Id === Number(x.UserId) : Id === Number(x.CompanyId)))
      let checked = checkedId !== undefined

      const disabled = this.state.task.IsUnsecified || (this.state.isUserChain && val.SubscriptionType !== 30)

      return (
        <Check key={key} labelText={name} disabled={disabled} id={Id} value={Id} checked={checked} onChange={this.onChangeList} />
      )
    }

    let assignOne = this.state.isUserChain ? translation('15143') : translation('15083')
    let assignAll = this.state.isUserChain ? translation('15144') : translation('15084')

    let actualAssigns = this.state.task.Assigns.filter(a => this.state.isUserChain ? a.CompanyId !== null : a.UserId !== null)
    let isAllChecked = false
    if (actualAssigns.length > 0 && this.state.isUserChain) {
      isAllChecked = list.every(s => !!actualAssigns.find(a => a.CompanyId === s.ShopId))
    } else {
      isAllChecked = list.every(e => !!actualAssigns.find(a => a.UserId === e.UserId))
    }

    return (
      <Panel title={translation(this.state.isUserChain ? '1861' : '10')} helpText={translation('1980')}>
        {!this.state.task.Deadline.OnlyOneDeadline && !isDisabled && (
          <div>
            <Radio key={'firstInstance'} labelText={assignOne} disabled={this.state.task.IsUnsecified} id='onlyFirst' name='AssignsOnlyFirst' checked={this.state.task.AssignsOnlyFirst} onChange={this.onClickCheckbox} />
            <Radio key={'allInstances'} labelText={assignAll} disabled={this.state.task.IsUnsecified} id='allOrc' name='AssignsOnlyFirst' checked={this.state.task.AssignsOnlyFirst === false} onChange={this.onClickCheckbox} />
          </div>
        )}
        <Check labelText={translation('531')} disabled={this.state.task.IsUnsecified} id='selectAll' name='all' checked={isAllChecked} onChange={this.onChangeList} />
        {list.map(assignsList)}
      </Panel>
    )
  }

  renderLog () {
    let className = this.state.isUserChain ? '' : 'shop'
    const renderStat = (stat, key) => {
      const renderEmpStat = (emp, empKey) => {
        return (
          <Grid key={empKey}>
            <span>{emp.Name}</span>
            <span>{emp.UsedTime}</span>
          </Grid>
        )
      }

      return (
        <TableRow cols={[1.25, 0.75]} key={key}>
          <span>
            <div className='company'>{stat.CompanyName}</div>
            {stat.Employees.length > 0 && stat.Employees.map(renderEmpStat)}
            <Grid>
              <span>{translation('15085')}</span>
              <span className='total-time'>{stat.TotaltimeUsed}</span>
            </Grid>
          </span>
          <span className='center'>{stat.Finished ? renderFullDate(stat.Finished) : translation('1233')}</span>
        </TableRow>
      )
    }

    // const showStats = (key) => {
    //   let Log = this.state.task.OtherTaskLog
    //   let changes = []
    //   let deadlines = []
    //   Log.map(x => { x.IsChange ? changes.push(x) : deadlines.push(x) })
    //   Log = changes
    //   deadlines[key].showStats = deadlines[key].showStats !== true
    //   Log = Log.concat(deadlines)

    //   this.setState({
    //     task: {
    //       ...this.state.task,
    //       OtherTaskLog: Log
    //     }
    //   })
    // }

    const openTask = (occurrenceId, deadline) => {
      let { CategoryId, Description, Name } = this.state.task
      let category = this.state.categories.filter(x => x.Id === CategoryId)[0].Name
      this.setState({
        taskOccurrence: {
          task: {
            OccurrenceId: occurrenceId,
            Deadline: deadline,
            Category: category,
            Description: Description,
            Title: Name
          }
        }
      }, () => {
        this.props.openOverlay('TaskOverlay')
      })
    }

    const renderChainItem = (val, key) => {
      if (val.IsChange) {
        return (
          <TableRow key={key} className='chain'>
            <span>{renderFullDate(val.Deadline, false)}</span>
            <span className='assigned'>{val.ChangedBy}</span>
            <span>{translation(enumtranslate('OtherTaskSections', val.Section))}</span>
          </TableRow>
        )
      }

      return (
        <TableExpand key={key}>
          <TableHeader className='chain' cols={[1, 1, 1, '32px', '24px']}>
            <span>{renderFullDate(val.Deadline, false)}</span>
            <span className='assigned'>{val.TotalAssignt}<span>{' ' + translation('1861')}</span></span>
            <span>{val.TotalFinished}/{val.TotalAssignt}<span>{' ' + translation('1861')}</span></span>
            <span>{val.Entries[0] && (<Icon icon={MainMenuIcons.Tasks_Black} onClick={openTask.bind(this, val.Entries[0].OccurrenceId, val.Deadline)} />)}</span>
          </TableHeader>
          <TableRow header cols={[1.25, 0.75]}>
            <span>{translation('64')}</span>
            <span>{translation('15087')}</span>
          </TableRow>
          {val.Entries.map(renderStat)}
        </TableExpand>
      )
    }

    const renderShopItem = (val, key) => {
      if (val.IsChange) {
        return (
          <TableRow key={key}>
            <span>{renderFullDate(val.Deadline, false)}</span>
            <span>{val.ChangedBy}</span>
            <span>{translation(enumtranslate('OtherTaskSections', val.Section))}</span>
          </TableRow>
        )
      }

      const renderStat = (emp, key) => {
        return (
          <TableRow key={'stat_' + key}>
            <span>{emp.Name}</span>
            <span>{renderFullDate(emp.StopTime)}</span>
            <span>{emp.UsedTime}</span>
          </TableRow>
        )
      }
      const hasData = val.Entries.length > 0
      return (
        <TableExpand key={key}>
          <TableHeader cols={[1, 1, 1, '32px', '24px']}>
            <span>{renderFullDate(val.Deadline, false)}</span>
            <span>{(hasData && val.Entries[0].Finished) ? renderFullDate(val.Entries[0].Finished) : translation('1233')}</span>
            <span>{hasData ? val.Entries[0].TotaltimeUsed : '00:00:00'}</span>
            <span>{hasData && (<Icon icon={MainMenuIcons.Tasks_Black} onClick={openTask.bind(this, val.Entries[0].OccurrenceId, val.Deadline)} />)}</span>
          </TableHeader>
          <TableRow header>
            <span>{translation('30')}</span>
            <span>{translation('15096')}</span>
            <span>{translation('575')}</span>
          </TableRow>
          {val.Entries[0].Employees.map(renderStat)}
        </TableExpand>
      )
    }

    const occurrences = this.state.task.OtherTaskLog.filter(otl => !otl.IsChange)
    const changes = this.state.task.OtherTaskLog.filter(otl => otl.IsChange)

    // <span className='expand-align' />
    return (
      <TableContainer>
        <div className={'log ' + className}>
          <div className='log-header'>
            <Grid cols={[1, 'min-content']} align={'center'}>
              <h3>{translation('1269')}</h3>
              {/* <HelpIcon helpText={translation('@')} /> */}
            </Grid>
          </div>
          <TableRow header cols={[1, 1, 1, '32px', '32px']}>
            <span>{translation('1232')}</span>
            {this.state.isUserChain && <span className='assigned'>{translation('15086')}</span>}
            <span>{translation('15087')}</span>
            {!this.state.isUserChain && <span>{translation('575')}</span>}
            <span />
            <span />
          </TableRow>
          {this.state.isUserChain ? occurrences.map(renderChainItem) : occurrences.map(renderShopItem)}
          <div className='log-header'><Grid><h3>{translation('1489')}</h3></Grid></div>
          <TableRow header>
            <span>{translation('388')}</span>
            <span>{translation('15231')}</span>
            <span>{translation('15232')}</span>
          </TableRow>
          {this.state.isUserChain ? changes.map(renderChainItem) : changes.map(renderShopItem)}
        </div>
      </TableContainer>
    )
  }

  render () {
    const categoriesList = (val, key) => {
      return (
        <option key={key} value={val.Id}>{translation(val.Name)}</option>
      )
    }

    const headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        if (this.state.DedlineChanged) {
          this.setState({
            ConfirmDedlineChange: true
          })
        } else {
          router.goBack()
        }
      }
      return <CloseButton key='back_close' ariaText={t('2060')} onClick={goBack} />
    }

    const isDisabled = this.state.task.IsChain && !this.state.isUserChain

    return (
      <div className='task__screen'>
        <Header router={this.props.router} showBack headerButtonsGoBack={headerButtonsGoBack} />
        <SideMenu disableFilter>
          <SideMenuCustomItem isFixed>
            {!isDisabled && this.renderButton()}
          </SideMenuCustomItem>
        </SideMenu>
        <LeftMenuContent className='tasks task__screen--inner'>
          <Row>
            <Col>
              <Panel title={translation('1227')}>
                <Text labelText={translation('30')} value={this.state.task.Name} name='Name' onChange={this.onChange} onBlur={this.updateTask} disabled={isDisabled} />
                <DropDown labelText={translation('1230')} onChange={this.onChangeNumber} name='CategoryId' value={this.state.task.CategoryId} disabled={isDisabled}>
                  {this.state.categories.map(categoriesList)}
                </DropDown>
                <Switch labelText={translation('295')} name='IsActive' checked={this.state.task.IsActive === true} onChange={this.onRadioChange} disabled={isDisabled} />
                <Textarea labelText={translation('1021')} value={this.state.task.Description ? this.state.task.Description : ''} name='Description' onChange={this.onChange.bind(this, 'Description')} onBlur={this.updateTask} disabled={isDisabled} />
                <Check id='unspecifiedTask' name='IsUnsecified' onChange={this.onClickCheckbox} checked={this.state.task.IsUnsecified} disabled={isDisabled} labelText={translation('15067')} />
                <div>
                  {this.renderFiles()}
                </div>
              </Panel>
              {this.renderDeadline()}
            </Col>
            <Col>
              {this.renderAssignList()}
            </Col>
            <Col span={2}>
              {this.renderLog()}
            </Col>
          </Row>
          {this.state.ConfirmDedlineChange && this.state.task.OtherTaskId !== 0 && (<Portal onPortalClose={() => {
            this.setState({ ConfirmDedlineChanged: false }, () => {
              this.props.router.goBack()
            })
          }}>
            <Confirm
              confirm={() => {
                this.setState({
                  task: {
                    ...this.state.task,
                    UseOldDeadline: false
                  },
                  ConfirmDedlineChange: false
                }, () => {
                  // this.props.router.goBack()
                })
              }}
              notConfirm={() => {
                this.setState({
                  task: {
                    ...this.state.task,
                    UseOldDeadline: true
                  },
                  ConfirmDedlineChanged: false
                }, () => {
                  this.updateTask().then(this.props.router.goBack())
                })
              }}
              renderText={() => {
                return (<div>{translation('15142')}</div>)
              }}
            />
          </Portal>)}
        </LeftMenuContent>
        <TaskOverlay task={this.state.taskOccurrence.task} />
      </div>
    )
  }
}

Tasks.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees
  }
}

export default connect(mapStateToProps, {
  getTask,
  createUpdateTask,
  fileUpload,
  fileDelete,
  getCategories,
  getShops,
  getDeadline,
  openOverlay
})(Tasks)



// WEBPACK FOOTER //
// ./src/app/pages/Tasks/Task/index.js